// src/App.js
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import './Dash.css';
import OrdersPage from '../../Components/Orders/Orders';
import Dashboard from '../../Components/Dashboard/Dashboard';
import DeliveriesPage from '../../Components/DeliveriesPage/DeliveriesPage';
import OrdersPagesec from '../../Components/OrdersPage/OrdersPage';


function App() {
  const [currentPage, setCurrentPage] = useState('Dashboard');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const renderContent = () => {
    switch (currentPage) {
      case 'Dashboard':
        return <div><Dashboard/></div>;
      case 'Orders':
        return <div><OrdersPage/></div>;
      case 'Deliveriessec':
        return <div><OrdersPagesec/>
          </div>;
      case 'Deliveries':
        return <div><DeliveriesPage/>
          </div>;
      case 'Team':
        return <div>Team Content</div>;
      default:
        return <div>Select a page</div>;
    }
  };

  return (
    <div className="app">
      {/* Hamburger Menu */}
      <button className="hamburger" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
        &#9776;
      </button>
      
      {/* Sidebar */}
      <Sidebar onPageChange={(page) => { setCurrentPage(page); setIsSidebarOpen(false); }} isOpen={isSidebarOpen} />

      {/* Main Content */}
      <main className="content">
        {renderContent()}
      </main>
    </div>
  );
}

export default App;




// // src/App.js
// import React, { useState } from 'react';

// import Sidebar from './Sidebar';
// //import Profile from './components/Profile';
// import Profile from './Profile';
// import './Dash.css';

// function App() {
//   const [isSidebarOpen, setSidebarOpen] = useState(false);

//   const toggleSidebar = () => {
//     setSidebarOpen(!isSidebarOpen);
//   };

//   return (
//     <div className={`app ${isSidebarOpen ? 'sidebar-open' : ''}`}>
//       <Sidebar />
//       <Profile />
//       <div className="overlay" onClick={toggleSidebar}></div>
//     </div>
//   );
// }

// export default App;
